module.exports = __webpack_public_path__ + "img/whiteuparrow.a0ead963.svg";